import React from "react";
import * as app from "../services/AppService"
export default function Spinner(props: { Loading: boolean, Waiting?: boolean }) {
    return (
        props.Loading || props.Waiting ? (
            <div>
                <div style={{ zIndex: 9999990 }}
                    className="d-flex justify-content-center align-items-center position-fixed bg-dark w-100 h-100  bg-opacity-50 ">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <div className="d-flex justify-content-center align-items-center spinner-border text-light fw-bold"
                            role="status" style={{ width: "7rem", height: "7rem" }}>
                            <div className="d-flex justify-content-center align-items-center spinner-border text-primary text-secoundary fw-bold"
                                role="status" style={{ width: "6rem", height: "6rem" }}>
                                <div className="spinner-border text-light text-secoundary fw-bold"
                                    role="status" style={{ width: "5rem", height: "5rem" }}>
                                </div>
                            </div>
                        </div>
                        {props.Waiting &&
                            <h2 className="text-light mt-3 text-center">
                                {app.translate("TakeFewMin")}
                            </h2>}
                    </div>

                </div>
            </div>
        ) : <></>
    );
}